import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '@emotion/react';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { BaseTransition } from './base-transition.js';

/**
 * Component that animates its content in and out with a subtle fade and scale effect.
 */ const AppearInOut = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('AppearInOut', props, ref);
    const { children, duration = 'fast', from = 'center', in: visible, initial, ...elementProps } = mergedProps;
    const theme = useTheme();
    const inTransition = {
        duration: typeof duration === 'number' ? duration : theme.motionDurations[duration],
        ease: theme.motionTimings.decelerate
    };
    const outTransition = {
        ...inTransition,
        duration: 0.09,
        ease: theme.motionTimings.accelerate
    };
    const enter = {
        scale: 1,
        opacity: 1,
        transition: inTransition
    };
    const exit = {
        scale: 0.95,
        opacity: 0,
        transition: outTransition
    };
    return /*#__PURE__*/ jsx(BaseTransition, {
        ...elementProps,
        ref: mergedRef,
        enter: enter,
        exit: exit,
        initial: initial,
        style: {
            transformOrigin: from
        },
        mounted: visible,
        children: children
    });
});

export { AppearInOut };
//# sourceMappingURL=appear-in-out.js.map
